import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import CustomButton from '../../../../components/forms/Button';
import { CheckCircleFilled } from '@ant-design/icons';
import { FaInfinity } from '@react-icons/all-files/fa/FaInfinity';
import { FaStar } from '@react-icons/all-files/fa/FaStar';
import './index.scss';
import { FaMagic } from '@react-icons/all-files/fa/FaMagic';
import { reportEvent } from '../../../../services/analyticsService';
import { useLocation } from 'react-router-dom';
import { postRequest } from '../../../../services/requestService';
import { PLANS } from './constants';
import { getCookie } from '../../../../services/clientService';




const GUARANTEES = [
  '14-day money-back guarantee',
  'Cancel anytime online, by email, or phone',
  'Trusted by hundreds of job seekers with a 4.9 average rating',
];

const PurchaseModal = ({  onPlanSelect, loadingPlanId, purchaseModalOpen, setPurchaseModalOpen }) => {
  const [selected, setSelected] = useState('trial');
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const handleSelect = (id) => setSelected(id);
  const handleContinue = async () => {
    try {
      setIsLoading(true);
      const selectedPlan = PLANS.find(plan => plan.id === selected);
      reportEvent('resume_builder_upgrade', 'start_checkout', { planId: selected });
      
      let generateCheckoutUrl = `billing/generate-checkout?planId=${selected}&productId=${selectedPlan.productId}`;
      if (getCookie('mode') === 'test') {
        generateCheckoutUrl = `billing/generate-checkout?planId=trial&productId=${selectedPlan.productId}&mode=test`;
      }
      const res = await postRequest(generateCheckoutUrl);
      
      if (res.data.checkoutPageUrl) {
        window.location.href = res.data.checkoutPageUrl;
      }
    } catch (error) {
      console.error('Checkout error:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const onClose = () => {
    setPurchaseModalOpen(false)
  }
  useEffect(() => {
    if (location.search.includes('signup=success')) {
        setPurchaseModalOpen(true)
    }
  }, [location])
  useEffect(() => {
    if (purchaseModalOpen) {
      reportEvent('resume_builder_upgrade', 'modal_open')
    }
  }, [purchaseModalOpen])

  return (
    <Modal
      open={purchaseModalOpen} 
      footer={null}
      className="purchase-modal"
      centered
      title={null} onCancel={onClose}
      bodyStyle={{ padding: 0 }}
    >
      <div className="purchase-modal__container">
        <div className="purchase-modal__logo-row">
          <img src="/logos/logo-genie-blue.png" alt="Genie logo" className="purchase-modal__logo" />
        </div>
        <h2 className="purchase-modal__title">Subscribe now and get unlimited resume downloads & more</h2>
        <div className="purchase-modal__plans">
          <div className={`purchase-modal__plan-card${selected === 'trial' ? ' selected' : ''}`} onClick={() => handleSelect('trial')}>
            <div className="purchase-modal__plan-header">
              <span className="purchase-modal__plan-label purchase-modal__plan-label--trial">7-day trial</span>
              <span className="purchase-modal__plan-best">BEST VALUE</span>
              <span className="purchase-modal__plan-price">$1.95</span>
            </div>
            <ul className="purchase-modal__plan-features">
              {PLANS[0].description.map((item, i) => (
                <li key={i}><span className="purchase-modal__plan-icon">{item.icon}</span>{item.text}</li>
              ))}
            </ul>
            <div className="purchase-modal__plan-renewal">{PLANS[0].renewal}</div>
          </div>
          <div className={`purchase-modal__plan-row${selected === '3mo' ? ' selected' : ''}`} onClick={() => handleSelect('3mo')}>
            <span className="purchase-modal__plan-label">3 months</span>
            <span className="purchase-modal__plan-onetime">One-time payment of</span>
            <span className="purchase-modal__plan-price">$27.88</span>
          </div>
          <div className={`purchase-modal__plan-row${selected === '6mo' ? ' selected' : ''}`} onClick={() => handleSelect('6mo')}>
            <span className="purchase-modal__plan-label">6 months</span>
            <span className="purchase-modal__plan-onetime">One-time payment of</span>
            <span className="purchase-modal__plan-price">$47.88</span>
          </div>
        </div>
        <CustomButton
          className="purchase-modal__continue-btn"
          onClick={handleContinue}
          loading={isLoading}
          style={{ width: '100%', height: 52, fontSize: 20, margin: '24px 0 0' }}
        >
          Continue
        </CustomButton>
        <ul className="purchase-modal__guarantees">
          {GUARANTEES.map((g, i) => (
            <li key={i}><CheckCircleFilled style={{ color: '#22c55e', marginRight: 8 }} />{g}</li>
          ))}
        </ul>
        <div className="purchase-modal__desc">
        Take control of your job search with Get In Genie Premium. Build as many customized resumes and cover letters as you need, and choose from advanced design options to make a lasting impression.
        </div>
      </div>
    </Modal>
  );
};

export default PurchaseModal;
